export default [{
  ".mithril-infinite__scroll-view.table.fixed": {
    " .mithril-infinite__scroll-content": {      
      " .mithril-infinite__page": {
        " .list-item": {
          maxHeight: "36px",
          overflowY: "hidden",
        }
      },
    }
  }
}];